import { useFormikContext } from 'formik'
import React from 'react'
import { Button } from 'react-bootstrap'

type Props = {
    formName?: string
    isView?: boolean
}

const ThaoTacGGT = ({ formName, isView }: Props) => {
    const { setFieldValue } = useFormikContext<any>();

    const handleHuyThongTin = () => {
        setFieldValue(`additionalForms.${formName}`, {});
    };

    return (
        <div className='spaces ml-50'>
            <Button className='btn-fill spaces min-w-200 mt-10' disabled={isView}>
                <i className="bi bi-arrow-repeat"></i>
                Giấy giới thiệu cũ
            </Button>
            <Button className='btn-fill spaces min-w-200 mt-15' disabled={isView}>
                <i className="bi bi-info-circle-fill"></i>
                Kiểm tra trên cổng BHXH
            </Button>
            <Button className='btn-fill spaces min-w-200 mt-15'
                onClick={handleHuyThongTin}
                disabled={isView}
            >
                <i className="bi bi-x-square-fill"></i>
                Hủy thông tin
            </Button>
        </div>
    )
}

export default ThaoTacGGT